import { render, staticRenderFns } from "./PurchaseAboutYou.vue?vue&type=template&id=34f9ea70&"
import script from "./PurchaseAboutYou.vue?vue&type=script&lang=js&"
export * from "./PurchaseAboutYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports